import Axios from 'axios'
import { StandardLineItem } from '../../../types/ShopFront/CheckoutStandards'
import { ConsignmentInput } from '../../Standardizers/augmentConsignments'
import { SHIPPING_RATE_API } from '../../Configuration'

type QuoteShippingRateNoDiscountArgs = {
  address?: ConsignmentInput['shippingAddress'],
  lineItems?: StandardLineItem[]
  selectedShippingOptionDescriptions?: string[] | undefined
}

const constructPayload = ({
  address,
  lineItems,
  selectedShippingOptionDescriptions,
}: QuoteShippingRateNoDiscountArgs) => {
  if (!address) {
    return undefined
  }
  if (!lineItems || !lineItems.length) {
    return undefined
  }
  const {
    city, stateOrProvinceCode, postalCode, country, address1, address2,
  } = address
  const lineItemsPayload = lineItems.map((lineItem) => {
    const {
      quantity, sku, productId,
    } = lineItem
    return {
      sku, product_id: productId, quantity,
    }
  })
  const payload = {
    base_options: {
      origin: {
        street_1: '8450 Broadway',
        street_2: '',
        zip: '46410',
        city: 'Merillville',
        state_iso2: 'IN',
        country_iso2: 'US',
        address_type: 'commercial',
      },
      destination: {
        street_1: address1,
        street_2: address2,
        zip: postalCode,
        city,
        state_iso2: stateOrProvinceCode,
        country_iso2: country,
        address_type: 'residential',
      },
      items: lineItemsPayload,
    },
    selectedShippingOptionDescriptions,
  }
  return payload
}

export const quoteShippingRateNoDiscount = async ({
  address, lineItems, selectedShippingOptionDescriptions,
}: QuoteShippingRateNoDiscountArgs) => {
  const payload = constructPayload({ address, lineItems, selectedShippingOptionDescriptions })
  if (!payload) {
    return undefined
  }
  try {
    const response = await Axios.post(`${SHIPPING_RATE_API}/quote`, payload)
    return response?.data?.amount as number | undefined
  } catch {
    return undefined
  }
}
